export default __webpack_public_path__ + "static/media/element5-digital-OyCl7Y4y0Bk-unsplash.9719d4a8.jpg";